// extracted by mini-css-extract-plugin
export default {"required":"AuditingQuestionHeader_required__YsrYN","help":"AuditingQuestionHeader_help__YNYqW","auditorInfo":"AuditingQuestionHeader_auditorInfo__dmr0J"};